export const withLiveParticipant = (replayUrl, audienceId) => {
  if (!audienceId) return replayUrl
  try {
    const url = new URL(replayUrl)
    url.searchParams.set('p', audienceId)
    return url.toString()
  } catch (error) {
    return replayUrl
  }
}
